import React from 'react';
import classes from './WhatToDoNext.module.scss';
import t from '@/utils/Language/ResourceCard-translations';
import ResourceAccessInstruction from '@/components/Resources/ResourceAccessInstruction/ResourceAccessInstruction';
import { accessEventHelpers } from '@/utils/helpers';

const WhatToDoNext = ({ accessEvent, className = '', numberToShow = false, showNotes, ...props }) => {
  const priorityOrder = ['phone', 'location', 'email', 'link', 'other'];
  let instructionsToShow = accessEvent.resource.access_instructions;

  if (!accessEventHelpers.isClosedLoopReferral(accessEvent)) {
    if (numberToShow) {
      instructionsToShow = instructionsToShow
        .filter((instruction) => priorityOrder.indexOf(instruction.access_type) >= 0)
        .sort((a, b) => {
          if (priorityOrder.indexOf(a.access_type) < priorityOrder.indexOf(b.access_type)) {
            return -1;
          } else if (priorityOrder.indexOf(a.access_type) > priorityOrder.indexOf(b.access_type)) {
            return 1;
          } else {
            return 0;
          }
        })
        .slice(0, numberToShow);
    }
  }

  return (
    <div className={`${classes.accessInstructionContainer} ${className}`}>
      {!accessEventHelpers.isClosedLoopReferral(accessEvent) ? (
        <>
          <div className={`${classes.wtdn} wtdn`}>
            <span className={classes.highlight}>{t('What to do next')}</span>
          </div>
          <div className={`${classes.accessInstructions} access-instructions`}>
            {instructionsToShow.map((instruction, index) => {
              return <ResourceAccessInstruction key={index} instruction={instruction} showNotes={showNotes} />;
            })}
          </div>
        </>
      ) : (
        <>
          {t('supporterName has forwarded your contact information to this organization and they will reach out to you soon.', {
            supporterName: accessEventHelpers.supporterName({ accessEvent })
          })}
        </>
      )}
    </div>
  );
};

export default WhatToDoNext;
